import Link from "next/link"

export const NotFound = () => {
    return (
        <div className="text-center">
            <h1 className="text-5xl font-bold my-10 leading-[3rem]">Page Not Found</h1>
            <p className="font-semibold">{`We're sorry but the requested page cannot be found.`}  Return to the <Link className="link link-primary" href="/">Homepage</Link> now.</p>
        </div>
    )
}